module.exports = __webpack_public_path__ + "img/mypage04.3c1a3a94.png";